import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopanchganicabbooking() {



const cardData = {
  keyword: "Pune to Panchgani Cab Booking",
  heading: "Lotus Cab: Pune to Panchgani Cab Booking",

  headingDescription:
    "Lotus Cab offers professional Pune to Panchgani Cab Booking services for comfortable and safe hill station travel. Whether you are planning a relaxing weekend, a family vacation, or a romantic getaway, our well-maintained AC sedans and SUVs ensure a smooth journey. Panchgani’s scenic ghats require experienced drivers, and our trained chauffeurs are skilled in safe hill driving. We provide transparent per-kilometer pricing with no hidden charges. Flexible one-way and round-trip packages are available to suit your travel plan. With 24/7 booking assistance and punctual pickup anywhere in Pune, we make your Panchgani trip stress-free and enjoyable.",

  top: "Top Places to Visit in Panchgani with Lotus Cab",

  topPlaces: [
    {
      title: "Table Land",
      description:
        "Table Land is the most famous attraction in Panchgani and one of the largest volcanic plateaus in Asia. It offers breathtaking panoramic views of the valleys and surrounding hills. Visitors enjoy horse riding and sightseeing across the vast open landscape. The sunrise and sunset views here are especially memorable. It is a perfect photography destination for families and couples. A cab trip from Pune makes visiting Table Land comfortable and convenient."
    },
    {
      title: "Sydney Point",
      description:
        "Sydney Point provides stunning views of Krishna Valley and Dhom Dam. It is one of the most peaceful viewpoints in Panchgani. The cool breeze and scenic surroundings create a relaxing atmosphere. Ideal for couples and nature lovers. Early morning visits offer clear valley views. Comfortable cab travel ensures smooth access to this scenic spot."
    },
    {
      title: "Parsi Point",
      description:
        "Parsi Point is a popular family attraction offering beautiful views of the dam and green hills. It is known for its clean surroundings and calm environment. Visitors often stop here during their Panchgani road trip. It is perfect for short breaks and photography. Local snack stalls add charm to the visit. A well-planned cab trip makes it easily accessible."
    },
    {
      title: "Mapro Garden",
      description:
        "Mapro Garden is famous for fresh strawberries, chocolates, and fruit products. It is a must-visit destination for food lovers. Families enjoy shopping and tasting seasonal delights. The garden restaurant serves popular dishes and desserts. It is especially vibrant during strawberry season. A comfortable cab journey ensures relaxed travel."
    },
    {
      title: "Devil’s Kitchen",
      description:
        "Devil’s Kitchen is a mysterious cave believed to be connected with the Pandavas. It attracts adventure seekers and history enthusiasts. The natural rock formations create a unique atmosphere. Visitors enjoy exploring the small cave structures. It is a short but interesting stop in Panchgani. Safe cab travel makes it easy to include in your itinerary."
    },
    {
      title: "Rajpuri Caves",
      description:
        "Rajpuri Caves are ancient caves with religious significance. Devotees visit these caves during pilgrimages. The peaceful environment adds spiritual value to the experience. The caves are surrounded by greenery. It is a unique cultural attraction in Panchgani. A round-trip cab makes visiting convenient."
    },
    {
      title: "Dhom Dam",
      description:
        "Dhom Dam is a scenic water reservoir near Panchgani. Visitors enjoy boating and photography here. The calm water and mountain backdrop create stunning visuals. It is ideal for short relaxation breaks. Many tourists combine it with a Panchgani trip. A comfortable SUV ensures smooth access."
    },
    {
      title: "Harrison’s Folly",
      description:
        "Harrison’s Folly is a peaceful viewpoint away from heavy crowds. It offers beautiful sunrise and sunset views. Perfect for couples and photographers. The cool climate makes it refreshing. It is less commercialized and very scenic. A cab ride ensures safe and easy travel."
    }
  ],

  services: [
    {
      name: "Pune to Panchgani Taxi Service",
      description:
        "Professional taxi service from Pune to Panchgani with safe hill driving expertise. AC sedans and SUVs are available for comfortable travel. Transparent per km pricing ensures clarity. Drivers are experienced in ghat sections. Flexible departure timings offered. Ideal for leisure and family trips."
    },
    {
      name: "Pune to Panchgani One Way Cab",
      description:
        "One-way cab service allows you to pay only for drop distance. Suitable for relocation or hotel transfer. Affordable and cost-effective option. Clean vehicles provided for comfort. Transparent billing policy followed. Convenient single-side travel solution."
    },
    {
      name: "Pune to Panchgani Round Trip Taxi",
      description:
        "Round-trip taxi offers flexible return scheduling. Ideal for weekend vacations. Driver remains available for return journey. Comfortable SUV options available. Transparent pricing maintained. Convenient travel for family outings."
    },
    {
      name: "Affordable Pune to Panchgani Cab",
      description:
        "Budget-friendly cab service without compromising quality. Competitive pricing across sedan and SUV categories. Clear fare estimation before booking. Ideal for regular travelers. Comfortable long-distance ride ensured. Cost-effective travel solution."
    },
    {
      name: "Luxury Cab Pune to Panchgani",
      description:
        "Luxury cab options provide premium seating comfort. Suitable for couples and executive travel. Clean and well-maintained vehicles. Professional chauffeurs ensure punctuality. Smooth and silent ride experience. Premium hill station travel guaranteed."
    },
    {
      name: "SUV Taxi Pune to Panchgani",
      description:
        "SUV taxis offer extra luggage and seating space. Perfect for group and family trips. Strong vehicles suitable for ghat roads. Comfortable interiors maintained. Safe and stable hill driving ensured. Ideal for weekend vacations."
    },
    {
      name: "Cheap Pune to Panchgani Taxi",
      description:
        "Affordable taxi service for budget travelers. Transparent per km fare structure. No hidden charges applied. Clean vehicles and polite drivers provided. Suitable for one-day trips. Reliable travel experience guaranteed."
    },
    {
      name: "Online Cab Booking Pune to Panchgani",
      description:
        "Instant online cab booking available 24/7. Quick confirmation provided. Flexible pickup scheduling supported. Multiple vehicle options available. Easy cancellation policies applied. Hassle-free booking experience ensured."
    }
  ],

  tableData: [
    ["Pune to Panchgani Cab Booking", "Pune to Panchgani Taxi Service"],
    ["Pune to Panchgani One Way Cab", "Pune to Panchgani Round Trip Taxi"],
    ["Affordable Pune to Panchgani Cab", "Luxury Cab Pune to Panchgani"],
    ["SUV Taxi Pune to Panchgani", "Cheap Pune to Panchgani Taxi"],
    ["Online Cab Booking Pune to Panchgani", "Best Cab Service Pune to Panchgani"],
    ["Pune to Panchgani Weekend Trip Cab", "Pune to Panchgani Family Trip Taxi"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Expert Hill Drivers",
      WhyChoosedescription:
        "Our drivers are trained for safe ghat driving. Smooth handling in hill sections ensured. Experienced in Panchgani routes. Safety is top priority. Comfortable and secure journey guaranteed."
    },
    {
      WhyChooseheading: "Transparent Fare Structure",
      WhyChoosedescription:
        "Clear per kilometer pricing policy followed. No hidden charges applied. Toll and parking details shared upfront. Complete cost clarity provided. Customers travel with confidence."
    },
    {
      WhyChooseheading: "Multiple Vehicle Options",
      WhyChoosedescription:
        "Sedan and SUV vehicles available. Suitable for couples and families. Clean and maintained fleet ensured. Comfortable seating provided. Flexible vehicle selection supported."
    },
    {
      WhyChooseheading: "One-Way & Round-Trip Flexibility",
      WhyChoosedescription:
        "Flexible one-way and return trip booking available. Adjustable return timing offered. Multi-day stay supported. Easy travel planning ensured. Convenient scheduling guaranteed."
    },
    {
      WhyChooseheading: "24/7 Booking Assistance",
      WhyChoosedescription:
        "Round-the-clock customer support provided. Immediate booking confirmation available. Quick response to queries. Reliable communication maintained. Hassle-free coordination ensured."
    },
    {
      WhyChooseheading: "Family-Friendly Travel",
      WhyChoosedescription:
        "Spacious vehicles for family trips. Extra luggage space provided. Safe driving ensured for children and seniors. Comfortable long journey experience. Relaxed travel atmosphere maintained."
    },
    {
      WhyChooseheading: "Well-Maintained Vehicles",
      WhyChoosedescription:
        "Vehicles regularly serviced and cleaned. AC functionality checked before departure. Comfortable interiors ensured. Reliable performance on highway and ghat roads. Smooth ride guaranteed."
    },
    {
      WhyChooseheading: "Affordable Pricing",
      WhyChoosedescription:
        "Competitive pricing structure maintained. Budget-friendly travel options available. Transparent fare estimation provided. No last-minute surprises. Cost-effective hill station travel."
    }
  ]
};

const faqData = [
  { question: "How far is Panchgani from Pune?", answer: "Panchgani is approximately 100 km from Pune. Travel time is around 2.5 to 3 hours depending on traffic and weather conditions." },
  { question: "Do you provide one-way cab to Panchgani?", answer: "Yes, one-way cab service is available. Customers pay only for drop distance without return fare charges." },
  { question: "Are SUVs recommended for Panchgani trip?", answer: "SUVs are recommended for family groups and ghat travel. They provide better comfort and luggage space." },
  { question: "Is round-trip cab available?", answer: "Yes, round-trip taxi with flexible return timing is available for weekend trips." },
  { question: "Is night travel safe to Panchgani?", answer: "Yes, experienced drivers ensure safe night travel through ghat sections." },
  { question: "Can I book online?", answer: "Yes, online booking is available 24/7 with instant confirmation." },
  { question: "Are toll charges included?", answer: "Toll charges are explained before booking and billed transparently." },
  { question: "What vehicles are available?", answer: "Sedan and SUV categories are available depending on group size and comfort preference." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended during peak tourist season." },
  { question: "Do you offer corporate bookings?", answer: "Yes, corporate and executive travel bookings are available." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Akshay Kulkarni",
    feedback: "Our weekend trip to Panchgani was smooth and comfortable. The driver handled ghat roads safely and the vehicle was clean. Pricing was transparent and clearly explained. Highly recommend Lotus Cab for hill station travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Sharma",
    feedback: "We booked an SUV for family trip. The cab arrived on time and was spacious. Fare was reasonable with no hidden charges. The driver was polite and professional. Great service overall.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Nikhil Patil",
    feedback: "Booked one-way cab from Pune to Panchgani. Transparent billing and smooth travel experience. Comfortable ride throughout. Very satisfied with service quality.",
    rating: 5
  }
];



















































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Panchgani Cab Booking",
  "image": "https://lotuscab.com/assets/images/pune-to-panchgani-cab-booking.jpg", 
  "description": "Lotus Cab offers Pune to Panchgani cab booking with affordable one way and round trip taxi services. Book sedan, SUV, and luxury cabs for weekend getaways, family trips, and comfortable outstation travel with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5900"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2799",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-panchgani-cab-booking"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Pune to Panchgani Cab Booking | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Panchgani cab with Lotus Cab. Affordable one way & round trip taxi for weekend & family trips. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Panchgani Cab Booking, Pune to Panchgani Taxi Service, Pune to Panchgani One Way Cab, Pune to Panchgani Round Trip Taxi, Affordable Pune to Panchgani Cab, Luxury Cab Pune to Panchgani, SUV Taxi Pune to Panchgani, Cheap Pune to Panchgani Taxi, Online Cab Booking Pune to Panchgani, Best Cab Service Pune to Panchgani, Pune to Panchgani Weekend Trip Cab, Pune to Panchgani Family Trip Taxi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/16.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetopanchganicabbooking;